// extracted by mini-css-extract-plugin
export default {"OnboardingStepMarker":"OnboardingSteps_OnboardingStepMarker__kNIz0","OnboardingStepWithSibling":"OnboardingSteps_OnboardingStepWithSibling__sniAx"};